<template>
  <div class="tag-filters" v-if="options.length">
    <span
      v-for="(item, ind) in options"
      :key="item.id"
      class="tag-filters-item"
      :class="{ 'selected': item.selected, 'disabled': item.disabled }"
      @click="handleClick(ind)"
    >{{item.name}}</span>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    // 默认单选
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selects: new Set(),
      selectedResult: []
    }
  },
  watch: {
    options: {
      handler() {
        this.clear()
      }
    }
  },
  methods: {
    clear() {
      this.selects.clear()
    },
    handleClick(ind) {
      const item = this.options[ind]
      if (item.disabled) return
      // 选中
      if (!item.selected) {
        // 单选
        if (!this.multiple) {
          if (this.selects.size) {
            // 之前已经选中过了，需要先把它取消选中
            this.selects.forEach(val => {
              const v = this.options[val]
              v.selected = false
            })
            this.selects.clear()
          }
        }
        this.selects.add(ind)
      // 取消选中
      } else {
        this.selects.delete(ind)
      }
      item.selected = !item.selected
      this.selectedResult = this.getResult()
      this.$emit('selected', this.selectedResult)
    },
    getResult() {
      const res = []
      this.selects.forEach(val => {
        res.push(this.options[val])
      })
      return res
    }
  }
}
</script>
<style lang="less" scoped>
  .tag-filters {
    background-color: #fff;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    &-item {
      border: 1px solid;
      border-color: rgba(0,0,0, 0.24);
      border-radius: 4px;
      padding: 5px 12px;
      font-size: 13px;
      color: rgba(0,0,0, 0.6);
      margin: 0 4px;
      white-space: nowrap;
      &.disabled {
        border-color: rgba(0,0,0, 0.12);
        color: rgba(0,0,0, 0.32);
      }
      &.selected {
        background: #e6eeff;
        border-color: #e6eeff;
        color: #2652ff;
      }
    }
  }
</style>